import React from 'react';

import {Portfolio} from '../../components';

export default Portfolio;


// WEBPACK FOOTER //
// ./src/pages/portfolio/index.js